import { render, staticRenderFns } from "./professionList.vue?vue&type=template&id=46ef396d"
import script from "./professionList.vue?vue&type=script&lang=js"
export * from "./professionList.vue?vue&type=script&lang=js"
import style0 from "./professionList.vue?vue&type=style&index=0&id=46ef396d&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports